import { render } from "./LaporanKpiGabunganSubKpiDetail.vue?vue&type=template&id=00ad0c8f&scoped=true"
import script from "./LaporanKpiGabunganSubKpiDetail.vue?vue&type=script&lang=js"
export * from "./LaporanKpiGabunganSubKpiDetail.vue?vue&type=script&lang=js"

import "./LaporanKpiGabunganSubKpiDetail.vue?vue&type=style&index=0&id=00ad0c8f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00ad0c8f"]])

export default __exports__